export default __webpack_public_path__ + "static/media/left-vector-login.0c034037.png";